export default class Semaphore {
  private maxConcurrency: number;
  private currentCount: number = 0;
  private queue: Array<() => void> = [];

  constructor(maxConcurrency: number) {
    this.maxConcurrency = maxConcurrency;
  }

  async acquire(): Promise<void> {
    if (this.currentCount < this.maxConcurrency) {
      this.currentCount++;
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      this.queue.push(resolve);
    });
  }

  release(): void {
    this.currentCount--;
    if (this.queue.length > 0) {
      this.currentCount++;
      const resolve = this.queue.shift();
      if (resolve) {
        resolve();
      }
    }
  }

  async runWithSemaphore(task: () => Promise<void>): Promise<void> {
    await this.acquire();
    try {
      await task();
    } finally {
      this.release();
    }
  }
}
